import OfferApproveToStageTwo from './OfferApproveToStageTwo';

export default OfferApproveToStageTwo;
